export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/custom_made_booth.0b146f7.svg";